import { render, staticRenderFns } from "./DepartmetnsSettings.vue?vue&type=template&id=2f528a30&scoped=true"
import script from "./DepartmetnsSettings.vue?vue&type=script&lang=js"
export * from "./DepartmetnsSettings.vue?vue&type=script&lang=js"
import style0 from "./DepartmetnsSettings.vue?vue&type=style&index=0&id=2f528a30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f528a30",
  null
  
)

export default component.exports